import React, { useState, useEffect } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import TextArea from 'antd/lib/input/TextArea';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import './PayDeliveryPage.scss';
import { Select } from 'antd';
import { id } from 'date-fns/locale';
import 'react-quill/dist/quill.snow.css';
import parse from 'html-react-parser';
import { nanoid } from 'nanoid';
import ReactQuill, { Quill } from 'react-quill';
import { htmlEditButton } from 'quill-html-edit-button';
import { useNavigate } from 'react-router-dom';

Quill.register('modules/htmlEditButton', htmlEditButton);

const AddConditions = () => {
    const nav = useNavigate();
    const { token, city } = useSelector((state) => state);
    const [title, setTitle] = useState('');
    const [descr, setDescr] = useState('');
    const [block, setBlock] = useState('');
    const [pageContent, setPageContent] = useState([]);
    const [lastContent, setLastContent] = useState([]);
    const [conditionsContent, setConditionsContent] = useState([]);

    const handleSelectChange = (value) => {
        setBlock(value);
    };

    const getDelivery = async () => {
        try {
            const response = await fetch(
                `${
                    process.env.REACT_APP_HOST ?? window.location.origin
                }/NewAdminPanel/pages/getPages`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ page: 'ShippingAndPayment', cityId: city.id }),
                }
            );

            if (!response.ok) {
                throw new Error('Ошибка HTTP: ' + response.status);
            }

            const responseData = await response.json();
            console.log(' responseData:', responseData);
            setLastContent(responseData.content.ru.slice(0, 13));
            setPageContent(responseData.content.ru[13].qa);
            setConditionsContent(responseData.content.ru[13].conditions);
        } catch (error) {
            console.error('Ошибка при получении страницы:', error);
        }
    };

    useEffect(() => {
        getDelivery();
    }, []);

    const onSubmit = async () => {
        try {
            const dataContent = lastContent || [
                {
                    title: 'Минимальный заказ',
                    text: '<p>от 400 ₽</p>',
                    id: 0,
                    subtext: '<p><br></p>',
                },
                {
                    title: 'Время приготовления',
                    text: 'от 30 мин',
                    id: 1,
                },
                {
                    title: 'Бесплатная доставка',
                    text: '<p>от 700 ₽</p>',
                    id: 2,
                },
                {
                    title: 'Доставка за город',
                    text: '<p>от 2000 ₽</p>',
                    id: 3,
                },
                {
                    title: 'Время доставки',
                    text: 'от 45 мин',
                    id: 4,
                },
                {
                    title: 'Доставка 46-120 мин',
                    text: '<p>Время доставки зависит от вашего адреса. Курьеру предоставляется +-16 минут от крайнего времени. В выходные и праздничные дни ожидание может быть увеличено.</p>',
                    id: 5,
                },
                {
                    title: 'Самовывоз от 30 мин.',
                    text: '<p>Долго ждать доставку?</p><p>Вы можете оформить самовывоз и забрать ваш заказ из любого удобного ресторана.</p><p>На самовывоз скидка 15%</p>',
                    id: 6,
                },
                {
                    title: 'Подтверждение заказа',
                    text: '<p>Откажитесь от звонка оператора, чтобы быстрее передать Ваш заказ в доставку.</p>',
                    id: 7,
                },
                {
                    title: '+7 (343) 317-17-17 (доб. 0)',
                    text: '<p>Позвоните нам, если нужно изменить заказ, время доставки, узнать статус заказа или отказаться.</p>',
                    id: 8,
                },
                {
                    title: 'Прием заказов',
                    text: '<p>Ежедневно: 11:00 - 23:30 +7 (343) 317-17-17 (доб. 0)</p>',
                    id: 9,
                },
                {
                    title: 'Стоимость',
                    text: '<p>Бесплатная от 700 руб и выше. </p><p>Бесплатная в отдаленные районы от 1500 руб. и выше.</p><p>См. карту "Зоны доставки".</p>',
                    id: 10,
                },
                {
                    title: 'Онлайн оплата',
                    text: '<p>Заказы в отдаленные районы города и все заказы с выше 5000, оплачиваются онлайн</p>',
                    id: 11,
                },
                {
                    title: 'Оплата',
                    text: '<p>Картой, СБП, Yandex Pay, наличными.</p><p>Расчетный счет.</p>',
                    id: 12,
                },
            ];

            const requestBody = {
                page: 'ShippingAndPayment',
                content: {
                    ru: [
                        ...dataContent,
                        {
                            qa: [...pageContent],
                            conditions: [
                                ...conditionsContent,
                                { question: title, answer: descr, id: nanoid() },
                            ],
                        },
                    ],
                },
                cityId: city.id,
            };

            const response = await fetch(
                `${
                    process.env.REACT_APP_HOST ?? window.location.origin
                }/NewAdminPanel/pages/getPages`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            // if (!response.ok) {
            //     throw new Error('Ошибка HTTP: ' + response.status);
            // }

            nav('/pay-delivery');
            // console.log(responseData);
            // notification.success({ message: "Условие доставки успешно добавлено" });
            // setTitle("");
            // setDescr("");
            // getDelivery();
        } catch (error) {
            console.error('Ошибка при получении страницы:', error);
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link', 'image', 'video'],
            ['clean'],
        ],
        htmlEditButton: {},
    };

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'indent',
        'link',
        'image',
    ];

    return (
        <div style={{ paddingTop: '110px', paddingLeft: '20px', width: '100%' }}>
            <Button text={'Вернуться'} onClick={() => window.history.back()} />
            <div
                style={{
                    background: 'white',
                    padding: '24px 16px',
                    borderRadius: '12px',
                    width: '800px',
                    margin: '20px auto 0',
                    display: 'block',
                }}
            >
                <h2 style={{ fontSize: '20px', textAlign: 'center' }}>Добавление</h2>
                <div
                    style={{
                        display: 'flex',
                        gap: '20px',
                        flexWrap: 'wrap',
                        flexDirection: 'column',
                        width: '75%',
                        margin: '20px auto 0',
                    }}
                >
                    <Input
                        style={{
                            border: '1.5px solid rgba(176, 194, 255, .6)',
                            borderRadius: '13px',
                        }}
                        placeholder={'Заголовок'}
                        maskType={String}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    {/* <TextArea
            className="DeliveryPage__textarea"
            placeholder="Текст"
            value={descr}
            onChange={(e) => setDescr(e.target.value)}
            rows={6}
          ></TextArea> */}
                    <ReactQuill
                        value={descr}
                        onChange={setDescr}
                        style={{ height: '200px', color: 'black' }}
                        formats={formats}
                        modules={modules}
                    />
                    {/* <Select
            className="DeliveryPage__select"
            showSearch
            placeholder="Где отображать"
            optionFilterProp="children"
            onChange={handleSelectChange}
            options={[
              {
                value: "0",
                label: "Верхний блок",
              },
              {
                value: "1",
                label: "Средний блок",
              },
              {
                value: "2",
                label: "Нижний блок",
              },
            ]}
          /> */}
                    <div style={{ margin: '70px auto 0' }}>
                        <Button text={'Создать'} onClick={onSubmit} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddConditions;
